import Vue from "vue";
import Vuex from "vuex";
import service from "../../services/grupos/schedules";
import schedules from "../../models/grupos/schedules";
import moment from "moment";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    service: new service(),
    schedules: [],
    new: [],
    edit: [],
    deleteItem: [],
    showAdd: false,
    openSchedule: false,
    mode: "",
    openDelete: false,
  },

  mutations: {
    setSchedules(state, data) {
      state.schedules = data;
    },
    setEdit(state, data) {
      state.edit = data;
    },

    setDeleteItem(state, data) {
      state.deleteItem = data;
    },
    setShowAdd(state, data) {
      state.showAdd = data;
    },

    setNew(state, data) {
      state.new = data;
    },
    setOpenSchedule(state, data) {
      state.openSchedule = data;
    },
    setMode(state, data) {
      state.mode = data;
    },

    setOpenDelete(state, data) {
      state.openDelete = data;
    },
  },
  actions: {
    async getSchedules(state, id) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getSchedules(id);

          state.commit("setSchedules", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },

    async edit(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.edit(state.state.edit).then(() => {
            let item = state.state.edit;
            let options = state.state.schedules;

            options = options.map((option) => {
              if (option.id !== item.schedule) {
                return option;
              }
              let fecHastaFormatted = item.to
                ? moment.utc(item.to, "YYYY-MM-DD").format("YYYY-MM-DD")
                : "";
              item = schedules.fromJson({
                grupoId: item.groupId,
                horarioId: item.schedule,
                fecDesde: item.from,
                fecHasta: fecHastaFormatted,
                segmId: item.segment,
                numSecuencia: item.sequenceNumber,
                segmDespl: item.initialDay,
                nomHorario: item.nameSchedule,
              });
              return item;
            });

            state.commit("setSchedules", options);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        }
      });
    },

    async new(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.new(state.state.new).then(({ data }) => {
            let item = state.state.new;
            let options = state.state.schedules;
            let newItem = schedules.fromJson({
              grupoId: item.groupId,
              horarioId: item.schedule,
              fecDesde: item.from,
              fecHasta: data.fecHasta,
              segmId: item.segment,
              numSecuencia: item.sequenceNumber,
              segmDespl: item.initialDay,
              nomHorario: item.nameSchedule,
            });
            options.push(newItem);

            state.commit("setSchedules", options);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        }
      });
    },
    async newSubGroup(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .newSubGroup(state.state.newSubGroups)
            .then(({ data }) => {
              let item = state.state.newSubGroups;
              let options = state.state.schedules;
              let newItem = groupsGt.fromJson({
                GrupoId: data.grupoId,
                Nombre: item.group,
              });
              options.push(newItem);

              state.commit("setSchedules", options);
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    async delete(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.delete(state.state.deleteItem).then(() => {
            let options = state.state.schedules;
            options = options.filter((option) => {
              return option.id != state.state.deleteItem.id;
            });
            state.commit("setSchedules", options);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
});
